
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.62 5.3a1 1 0 00-1-.92h-2.68L16.61.85a1 1 0 00-1-.91H8.37a1 1 0 00-1 .91l-.32 3.53H4a1 1 0 00-1 .94L2 22.93a1 1 0 00.27.75A1 1 0 003 24h18a1 1 0 00.73-.32 1 1 0 00.27-.76zM9.28 1.94h5.42l.23 2.44H9.06zM4.06 22L5 6.38h1.87l-.16 1.76a1 1 0 002 .18l.17-1.94h6.23l.18 2a1 1 0 001 .9h.09a1 1 0 00.91-1.09l-.16-1.76h1.57L19.92 22z"}})])
          )
        }
      }
    